import { useQuery } from "@tanstack/react-query";
import type { Cart } from "@spare-cart/contracts/cart";
import { apiClient } from "@core/api";
import { cartKeys } from "@modules/shared";

export const useCart = () =>
  useQuery({
    queryKey: cartKeys.detail(),
    queryFn: () => apiClient.get<Cart>("/cart"),
  });
